/**
 * Query keys used by auth, subscription, onboarding, and other flows.
 * When merging filter params into the URL, keep these unless explicitly updated.
 */
export const URL_QUERY_FLOW_KEYS = Object.freeze([
  'cid',
  'i',
  'select',
  'subscription',
  'paymentId',
  'from',
  'invitationId',
]);

/**
 * Shared report filters: every report-style page (dashboards, timeline, app
 * usage, screenshots, url tracking, teams reporting, user attendance). Same
 * keys in the query string so links between them can preserve member,
 * range, and timezone.
 */
export const REPORT_FILTER_QUERY = Object.freeze({
  member: 'member',
  start: 'start',
  end: 'end',
  tz: 'tz',
  /** Selected team id (e.g. teams reporting). */
  team: 'team',
  /** Optional report status filter (currently used by teams timeline). */
  status: 'status',
});

/**
 * Add Employee / Employee List / Department List (shareable deep links).
 * `team` matches {@link REPORT_FILTER_QUERY.team} for consistency.
 */
export const EMPLOYEE_PAGE_QUERY = Object.freeze({
  company: 'company',
  team: 'team',
  /** Free-text roster search — Employee List (name/email/role) and Department List (team name). */
  search: 'search',
  /** Role filter pill — Employee List only. */
  role: 'role',
});
